import { PrintPane } from './components/PrintPane';
import { WorkbookView } from './components/WorkbookView';
import { FormulaBar } from './components/formula/FormulaBar';
import { Ribbon } from './components/ribbon/Ribbon';
import './index.css';
import { Sheet } from './model/sheet';
import { Workbook } from './model/workbook';
import { init } from './utils/selectUtils';
import { icons as fluentIcons } from '@iconify-json/fluent';
import { icons as materialsSymbolsIcons } from '@iconify-json/material-symbols';
import { addCollection } from '@iconify/react';
import { useState } from 'react';

addCollection(fluentIcons);
addCollection(materialsSymbolsIcons);

export function App() {
  const [workbook] = useState(() => {
    const workbook = new Workbook();
    const sheet = new Sheet('Sheet 1');

    workbook.sheets.push(sheet);

    return workbook;
  });

  return (
    <div className="relative flex min-h-screen flex-col bg-gray-100">
      <div className="flex flex-col gap-1">
        <Ribbon />
        <FormulaBar />
      </div>
      <div className="flex h-full w-full grow flex-row">
        <WorkbookView workbook={workbook} />
        <PrintPane />
      </div>
    </div>
  );
}

init();

export default App;
